import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCXucVbch1fLvnuTY_5MIWM4yf-B3gwZUw",
  authDomain: "netflix-clone-170ff.firebaseapp.com",
  projectId: "netflix-clone-170ff",
  storageBucket: "netflix-clone-170ff.appspot.com",
  messagingSenderId: "829930871474",
  appId: "1:829930871474:web:1f4ad8a2aaf5eaae5c47ab",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { auth };
export default db;
